import { useState } from "react";
import { t } from "i18next";

import { BadgesSimple } from "@/shared/components/molecules/BadgesSimple";
import { Select } from "@/shared/components/organisms/Select";
import Stacked from "@/shared/components/molecules/Stacked";
import TabsUI from "@/shared/components/atoms/TabsUI";

const options = [
  { id: 1, name: "Demo GYM" },
  { id: 2, name: "Test GYM" },
  { id: 3, name: "Fitmewise GYM" },
];

export const LeadBusinessStagePage = () => {
  const task = t("lead.views.tasks");
  const notes = t("lead.views.notes");
  const businessStage = t("lead.views.business_stage_registration");
  const tabs = [
    {
      name: task,
      href: "/leads/tasks",
      current: true,
    },
    {
      name: notes,
      href: "/leads/notes",
      current: false,
    },
    {
      name: businessStage,
      href: "/leads/business-stage",
      current: false,
    },
  ];
  const [selectedOption, setSelectedOption] = useState(options[0]);

  return (
    <div className="mx-auto  px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto grid max-w-2xl grid-cols-1 grid-rows-1 items-start gap-x-8 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <Stacked />
        <div className="flex-1 col-start-2 col-end-4">
          <div className="px-4">
            <TabsUI tabs={tabs} current={task} />
          </div>
          <div className="mt-1   w-full">
            <div className="mt-3">
              <Select
                selected={selectedOption}
                setSelected={setSelectedOption}
                options={options}
                tittle=""
              />
            </div>
            <BadgesSimple />
          </div>
        </div>
      </div>
    </div>
  );
};
